<template>
  <div id="Dashboard"  class="container is-fluid"
    style="min-height:100vh;"
    @drop.prevent="dragFile" @dragover.prevent
  >

    <!-- Header -->
    <HeroContainer title="Shipping Spreadsheet Upload" />

    <link href="https://fonts.googleapis.com/icon?family=Material+Icons"
      rel="stylesheet">


    <!-- Modal upload dialog box -->
    <div id="modal_upload" class="modal">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div style="display:flex;align-items: center;justify-content: center;">
          
          <div style="margin-bottom:1em;">
            <div style="color:#42b983; font-size:1.2em; margin-bottom:2em;">
              <p style="color:#42b983; font-size:1.5em;">Uploading:</p>
              <ul id="upload_file_names">

              </ul>
            </div>
            <p style="color:white;">
              Tracking data will be appended to the spreadsheet.
            </p>
            <div class="buttons is-right" style="margin-top:1em">
              <button class="button is-danger" @click="cancelModal">Cancel</button>
              <button class="button is-success" @click="ajaxUpload">Submit</button>
              
            </div>
          </div>
        </div>
      </div>
      <button class="modal-close is-large" @click="cancelModal"></button>
    </div>

    <section id="filters" style="display:flex; justify-content:center;">
      <div style="width:500px" >

        <p style="margin-bottom:1em;">
          Upload a new spreadsheet by dragging a file or using the button. Tracking data will be appended to the spreadsheet.
        </p>
        <p style="margin-bottom:1em;">
          Make sure <strong>Tracking Number</strong> is a column in the spreadsheet.
        </p>
        <input ref="fileInput" type="file" style="display:none" v-on:change="onFilePicked"/>
        <div class="buttons is-right">
          <button @click='$refs.fileInput.click()' class="button is-info">Upload Spreadsheet</button>
        </div>
      </div>
    </section>


  </div>
</template>


<script>
import DataFrame from "dataframe-js";
import {
  DASHBOARD_PARTS_SHIPPING_SPREADSHEET_UPLOAD
} from '@/data/url';
import HeroContainer from '@/components/shared/HeroContainer.vue';

export default {
  name: 'DashboardShippingSpreadsheetUpload',
  components: {
    HeroContainer,
  },
  data: function(){
    return {
      upload_files: [],
    };
  },
  methods: {
    onFilePicked (event) {
      this.upload_files = []
      let fnames = document.getElementById('upload_file_names')
      let modal = document.getElementById('modal_upload')
      const files = event.target.files
      let f = files[0]
      if(f.name.toLowerCase().includes('.xls') | f.name.toLowerCase().includes('.xlsx') | f.name.toLowerCase().includes('.csv')){
            modal.classList.add('is-active')
            let li = document.createElement('li')
            li.innerText = f.name
            fnames.appendChild(li)
            this.upload_files.push(f);
          }else{
            alert('Spreadsheet must be Excel or CSV format.')
          }
    },
    dragFile(e){
      this.upload_files = []
      let fnames = document.getElementById('upload_file_names')
      let modal = document.getElementById('modal_upload')
      let droppedFiles = e.dataTransfer.files;
      if(!droppedFiles) return; 
      ([...droppedFiles]).forEach(f => {
          if(f.name.toLowerCase().includes('.xls') | f.name.toLowerCase().includes('.xlsx') | f.name.toLowerCase().includes('.csv')){
            modal.classList.add('is-active')
            let li = document.createElement('li')
            li.innerText = f.name
            fnames.appendChild(li)
            this.upload_files.push(f);
          }else{
            alert('Spreadsheet must be Excel or CSV format.')
          }        
      });
    },
    cancelModal(){
      document.getElementById('modal_upload').classList.remove('is-active')
      this.upload_files = []
      let fnames = document.getElementById('upload_file_names')
      fnames.innerText = ''
    },
    set_searching(is_searching){
      this.searchStore.set_ajax_searching(is_searching)
    },
    ajaxUpload(){
      this.set_searching(true)
      let url = DASHBOARD_PARTS_SHIPPING_SPREADSHEET_UPLOAD
      let this_vue = this
      // Aggregate the files for upload
      let formData = new FormData();
      this.upload_files.forEach((f) => {
        formData.append(f.name, f);
      });
      var filename = this.upload_files[0].name
      function do_download(spreadsheet){
        // Create dataframe from data
        let df = new DataFrame(spreadsheet) 
        
        // Create CSV and download via browser
        // eslint-disable-next-line no-unused-vars
        let csv = df.toCSV(df)
    
        this_vue.$emit('download-csv', [spreadsheet, filename, null, false])
      }
      function alert_error(error){
        alert(error)
      }
      fetch(url, {
        method:'POST',
        body: formData
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
          do_download(res.data)
        }else{
          if(res.error){
            alert_error(res.error)
          }
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        console.error(JSON.stringify(e.message));
      });
      this.cancelModal()
    },
  }
};

</script>
